import { render, staticRenderFns } from "./v-icon.vue?vue&type=template&id=f370254c&scoped=true&"
import script from "./v-icon.vue?vue&type=script&lang=js&"
export * from "./v-icon.vue?vue&type=script&lang=js&"
import style0 from "./v-icon.vue?vue&type=style&index=0&id=f370254c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f370254c",
  null
  
)

export default component.exports